<template>
    <v-main>
        <v-row class="mt-n16">
            <v-col cols="10" class="mb-n10">
                <h2 class="ml-4 mb-7"><v-icon>mdi-cards-playing-outline</v-icon> 견적 옵션 관리</h2>
            </v-col>
            <v-col cols="2">
                <AddCommonDataButton
                    :key="codeKey"
                    :code="selectedCode.code"
                    :name="selectedCode.name"
                    :category="category"
                    @click="updateTableKey"
                ></AddCommonDataButton>
            </v-col>
        </v-row>

        <v-row v-if="selectedCode.code == 'paper1' || selectedCode.code == 'paper2'" class="mb-n7 mt-n5">
            <v-col cols="12">
                <v-radio-group row label="용지사이즈"
                v-model="category"
                @change="updateTableKey">
                    <v-radio
                        label="하드롱"
                        color="info"
                        value="ps1"
                        
                    ></v-radio>
                    <v-radio
                        label="4 X 6"
                        color="info"
                        value="ps2"
                    ></v-radio>
                    <v-radio
                        label="국전"
                        color="info"
                        value="ps3"
                    ></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>

        <v-row v-if="commonCodeList.length > 0" class="mb-n5">
            <v-col cols="12">
                <v-select
                v-model="selectedCode"
                :items="commonCodeList"
                item-text="name"
                item-value="code"
                filled
                dense
                return-object
                label="옵션을 선택하세요."
                ></v-select>
            </v-col>
        </v-row>

        <v-row v-if="commonCodeList.length == 0">
            <v-col cols="12" sm="6">
                <ul>
                    <li class="ml-4 mb-1">
                        등록된 옵션이 없습니다.
                    </li>
                </ul>
            </v-col>
        </v-row>

        <v-row>
            <commonDataTable :key="tableKey" :category="category" :selectedCode="selectedCode"></commonDataTable>
        </v-row>
    </v-main>

</template>

<script>
import axios from "axios";
import AddCommonDataButton from "@/components/admin/button/AddCommonDataButton"
import CommonDataTable from '@/components/admin/table/CommonDataTable'

export default {
    name: 'CommonDataWidget',
    components: {
        AddCommonDataButton,
        CommonDataTable,
    },
    data: () => ({
        selectedCode: {'code':'paper1', 'name': '지류가격1'},
        selectedName: null,
        commonCodeList: [],
        groupSetting: {},
        codeKey: 0,
        tableKey: 0,
        category: 'ps1'
    }),
    watch: {
        selectedCode: function(code) {
            if(code != null){
                this.selectedCode = code
                this.codeKey = Math.random(0, 1000)
            }
        },
    },
    methods: {
        async getCommonCode() {
            return axios({
                method: 'GET',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/setting/commonCode/getList',
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    console.log('commonCode/getList')
                    console.log(response.data)

                    if(response.data != null && response.data.status == '0000'){

                        this.commonCodeList = response.data.data

                    }else{

                        this.commonCodeList = []

                    }

                })
                .catch(() => {

                    //뭔가 실패 시

                })
        },
        async getCommonDataList(code) {
            return axios({
                method: 'GET',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/setting/commonData/getList/' + code,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    console.log('commonCode/getCommonDataList')
                    console.log(response.data)

                    if(response.data != null && response.data.status == '0000'){

                        this.commonCodeList = response.data.data

                    }else{

                        this.commonCodeList = []

                    }

                })
                .catch(() => {

                    //뭔가 실패 시

                })
        },
        async deleteNotifyTo(id) {

            if(confirm('정말 삭제하시겠습니까?')){

                return axios({
                    method: 'POST',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                    },
                    url: this.$store.getters.getApiUrl + '/api/v1/setting/deleteNotifyTo/' + id,
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                .then(response => {

                    if(response.data != null && response.data.status == '0000'){

                        alert(response.data.message)
                        this.getNotifyTo()

                    }else{

                        alert(response.data.message)

                    }

                })
                .catch(() => {

                    //뭔가 실패 시
                    alert('연락처 삭제에 실패했습니다.')
                    this.$rollbar.error('연락처 삭제 실패', this.$el)

                })

            }

        },
        updateTableKey() {
            this.tableKey = Math.random(0, 1000)
        }
    },
    created: function() {
        if(this.$store.getters.getAccessToken != null){
            this.groupSetting = this.$store.getters.getGroupSetting
        }
        this.getCommonCode()
    }
}
</script>